
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import Logo from "./navbar/Logo";
import MobileMenu from "./navbar/MobileMenu";
import NavActions from "./navbar/NavActions";
import { NavLinks } from "./navbar/NavLinks";
import { useIsMobile } from "@/hooks/use-mobile";

const NavBar = () => {
  const { user } = useAuth();
  const isMobile = useIsMobile();

  return (
    <header className="bg-background border-b sticky top-0 z-50 w-full backdrop-blur-sm bg-background/80">
      <div className="container mx-auto px-4 flex h-16 items-center justify-between">
        <div className="flex items-center">
          <Logo />
        </div>
        
        <div className="hidden md:flex items-center space-x-6">
          <NavLinks />
        </div>
        
        <div className="flex items-center space-x-4">
          <NavActions />
          
          {!user && (
            <Link to="/auth" className="hidden md:block">
              <Button variant="default" size="sm" className="bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-white font-semibold px-6 transition-all duration-300 hover:scale-105">
                Join Now! 🚀
              </Button>
            </Link>
          )}
          
          {/* Mobile menu */}
          {isMobile && <MobileMenu />}
        </div>
      </div>
    </header>
  );
};

export default NavBar;
